var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9795 2.74382C11.6379 -0.914607 17.5978 -0.914607 21.2562 2.74382C24.9146 6.40225 24.9146 12.3621 21.2562 16.0284C17.9945 19.2901 12.9156 19.6392 9.25717 17.0918C9.17781 17.4569 9.00322 17.8061 8.71753 18.0838L3.38464 23.4167C2.60693 24.1944 1.35306 24.1944 0.583286 23.4167C-0.194428 22.639 -0.194428 21.3851 0.583286 20.6154L5.91618 15.2825C6.19393 15.0047 6.54311 14.8222 6.90816 14.7508C4.36869 11.0844 4.71786 6.00546 7.9795 2.74382ZM9.6619 14.3381C12.3918 17.068 16.8438 17.068 19.5738 14.3381C22.3037 11.6082 22.3037 7.15615 19.5738 4.42622C16.8438 1.69629 12.3918 1.69629 9.6619 4.42622C6.92403 7.16409 6.92403 11.6082 9.6619 14.3381Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.27af1a8f.svg";
export { ForwardRef as ReactComponent };